import { gql } from "@apollo/client";

export const UpdateSqlNumberConfig = gql`
  mutation UpdateSqlNumberConfig(
    $token: String!
    $customerID: ID!
    $companyID: ID!
    $sqlNumberConfigId: ID!
    $user_details: SubscribedUser!
    $input: SqlNumbersConfig!
  ) {
    UpdateSqlNumberConfig(
      token: $token
      customerID: $customerID
      companyID: $companyID
      sqlNumberConfigId: $sqlNumberConfigId
      user_details: $user_details
      input: $input
    )
  }
`;
